var exports = {
  "w": "xfd349460--afa91c--header",
  "k": "xfd349460--afa91c--container",
};

module.exports = exports;
